module.exports = __webpack_public_path__ + "img/user.d11ca821.svg";